var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        {
          staticClass: "ma-0 pa-0 pl-3 pr-3",
          attrs: { cols: "12", id: "head_title" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0",
              attrs: { align: "center", id: "header_height" },
            },
            [
              _c(
                "router-link",
                {
                  staticStyle: { color: "transparent" },
                  attrs: { to: { path: _vm.$routerHistory.previous().path } },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0",
                      staticStyle: {
                        color: "#08B0FF",
                        "font-size": "1rem",
                        "text-align": "center",
                      },
                      attrs: { cols: "auto", align: "center" },
                    },
                    [_vm._v(" " + _vm._s(_vm.t("storeSearch")) + " ")]
                  ),
                ],
                1
              ),
              _c("v-img", {
                staticClass: "ma-0 pa-0 mr-3",
                attrs: {
                  "max-height": "100%",
                  "max-width": "1.5rem",
                  src: require("@/assets/images/history_arrow.png"),
                },
              }),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                [_vm._v(" " + _vm._s(_vm.tsc("searchList")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "ma-0 pa-0",
          attrs: { id: "main_content_minwidthset", cols: "12" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0",
              attrs: { id: "left_info_box", align: "start" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-3 pr-1",
                  attrs: { cols: "2", align: "left" },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "mb-2 mt-2 ml-2 pa-0 fontSet",
                      staticStyle: { "font-size": "0.8rem", color: "#008DD0" },
                      attrs: { align: "center", width: "auto", height: "2rem" },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.tsc("brand")) + " "),
                      _c("v-img", {
                        staticClass: "ma-0 pa-0 ml-2",
                        attrs: {
                          "max-height": "1rem",
                          "max-width": "0.6rem",
                          src: require("@/assets/images/blue_right_icon.png"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-3 pt-0 pb-1 fontSet",
                      attrs: { cols: "auto" },
                    },
                    [_vm._v(" " + _vm._s(_vm.tsc("brand")) + ": ")]
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                    _vm._l(
                      _vm.searchCondition.selectedBrands,
                      function (brand, index) {
                        return _c(
                          "v-col",
                          {
                            key: index,
                            staticClass: "ma-0 pa-3 pr-0 pt-0 pb-1",
                            attrs: { cols: "auto" },
                          },
                          [_vm._v(" " + _vm._s(brand.brandName) + " ")]
                        )
                      }
                    ),
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-3 pt-0 pb-1 mt-7",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("v-divider", {
                        staticClass: "ma-0 pa-0",
                        attrs: { id: "middle_divider" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "mb-2 mt-2 ml-2 pa-0 fontSet",
                      staticStyle: { "font-size": "0.8rem", color: "#008DD0" },
                      attrs: { align: "center", width: "auto", height: "2rem" },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.tsc("region")) + " "),
                      _c("v-img", {
                        staticClass: "ma-0 pa-0 ml-2",
                        attrs: {
                          "max-height": "1rem",
                          "max-width": "0.6rem",
                          src: require("@/assets/images/blue_right_icon.png"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-3 pt-0 pb-1",
                      attrs: { align: "center" },
                    },
                    _vm._l(
                      _vm.searchCondition.selectedAreas,
                      function (area, index) {
                        return _c(
                          "v-col",
                          {
                            key: index,
                            staticClass: "ma-0 pa-0 pr-2",
                            attrs: { cols: "auto" },
                          },
                          [_vm._v(" " + _vm._s(area) + " ")]
                        )
                      }
                    ),
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-3 pt-0 pb-1 mt-4",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("v-divider", {
                        staticClass: "ma-0 pa-0",
                        attrs: { id: "middle_divider" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "mb-2 mt-2 ml-2 pa-0 fontSet",
                      staticStyle: { "font-size": "0.8rem", color: "#008DD0" },
                      attrs: { align: "center", width: "auto", height: "2rem" },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.t("filtering")) + " "),
                      _c("v-img", {
                        staticClass: "ma-0 pa-0 ml-2",
                        attrs: {
                          "max-height": "1rem",
                          "max-width": "0.6rem",
                          src: require("@/assets/images/blue_right_icon.png"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-3 pt-0 pb-1",
                      attrs: { cols: "auto" },
                    },
                    [
                      _vm.searchCondition.setFilterConditions.motionBeginDate !=
                      ""
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.t("motionDetect") +
                                      " " +
                                      _vm.searchCondition.setFilterConditions.motionBeginDate
                                        .substr(0, 19)
                                        .replace("T", " ")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.searchCondition.setFilterConditions
                        .motionEndingDate != ""
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "~ " +
                                      _vm.searchCondition.setFilterConditions.motionEndingDate
                                        .substr(0, 19)
                                        .replace("T", " ")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.searchCondition.setFilterConditions.soundBeginDate !=
                      ""
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.t("soundDetect") +
                                      " " +
                                      _vm.searchCondition.setFilterConditions.soundBeginDate
                                        .substr(0, 19)
                                        .replace("T", " ")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.searchCondition.setFilterConditions.soundEndingDate !=
                      ""
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "~ " +
                                      _vm.searchCondition.setFilterConditions.soundEndingDate
                                        .substr(0, 19)
                                        .replace("T", " ")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-3 pt-0 pb-1 mt-4",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("v-divider", {
                        staticClass: "ma-0 pa-0",
                        attrs: { id: "middle_divider" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "mb-2 mt-2 ml-2 pa-0 fontSet",
                      staticStyle: { "font-size": "0.8rem", color: "#008DD0" },
                      attrs: { align: "center", width: "auto", height: "2rem" },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.t("tag")) + " "),
                      _c("v-img", {
                        staticClass: "ma-0 pa-0 ml-2",
                        attrs: {
                          "max-height": "1rem",
                          "max-width": "0.6rem",
                          src: require("@/assets/images/blue_right_icon.png"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-3 pt-0 pb-1",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "start", justify: "start" },
                        },
                        _vm._l(_vm.tagList, function (item) {
                          return _c(
                            "v-col",
                            {
                              key: item.label,
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass:
                                      "ma-0 pa-2 pt-0 pb-0 pl-3 pr-3 mr-1 mb-2",
                                    staticStyle: {
                                      "border-radius": "25px",
                                      "font-size": "0.8rem",
                                    },
                                    attrs: {
                                      width: "auto",
                                      height: "auto",
                                      id: "blue_btn",
                                      elevation: "0",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(item.label) + " ")]
                                ),
                              ],
                            ],
                            2
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mb-10", attrs: { cols: "10" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pa-0",
                      attrs: { id: "main_content_maxwidthset", cols: "12" },
                    },
                    [
                      _vm.fetchLoading == false
                        ? _vm._l(_vm.storeList, function (item, index) {
                            return _c(
                              "v-col",
                              {
                                key: index,
                                staticClass: "ma-0 pa-0 pl-5 pr-5 pb-5 mb-5",
                                staticStyle: {
                                  "border-bottom": "1px solid #4C4C4C",
                                },
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0 mt-2 mb-2",
                                    attrs: {
                                      align: "center",
                                      justify: "space-between",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { align: "center" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 ml-5",
                                            staticStyle: {
                                              "font-weight": "bold",
                                            },
                                            attrs: {
                                              cols: "auto",
                                              align: "left",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.customerName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0 pl-5",
                                    attrs: { align: "start" },
                                  },
                                  [
                                    item.numberOfUas == 0
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 pr-4",
                                            attrs: { cols: "3" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: {
                                                  id: "data_box",
                                                  cols: "12",
                                                },
                                              },
                                              [
                                                _c("v-row", {
                                                  staticClass: "ma-0 pa-0",
                                                  staticStyle: {
                                                    height: "11.45rem",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 pr-4",
                                            attrs: { cols: "3" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                staticStyle: {
                                                  cursor: "pointer",
                                                },
                                                attrs: {
                                                  id: "data_box",
                                                  cols: "12",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goStoreAnalyze(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-3 pl-5 pr-5",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0 mb-1",
                                                        attrs: { cols: "12" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            staticStyle: {
                                                              "font-weight":
                                                                "bold",
                                                            },
                                                            attrs: {
                                                              align: "center",
                                                              justify:
                                                                "space-between",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  id: "data_sub_title",
                                                                  cols: "auto",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.tsc(
                                                                        "last30DaysVisitors"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  cols: "auto",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-row",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-0",
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "#008DD0",
                                                                        "font-size":
                                                                          "0.8rem",
                                                                      },
                                                                    attrs: {
                                                                      align:
                                                                        "center",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.tsc(
                                                                            "viewAnalyze"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "v-img",
                                                                      {
                                                                        staticClass:
                                                                          "ma-0 pa-0 ml-2",
                                                                        attrs: {
                                                                          "max-height":
                                                                            "0.8rem",
                                                                          "max-width":
                                                                            "0.8rem",
                                                                          src: require("@/assets/images/blue_right_icon.png"),
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          id: "data_people_box",
                                                          cols: "12",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              align: "center",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-1",
                                                                attrs: {
                                                                  cols: "6",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-0 pl-2",
                                                                    attrs: {
                                                                      id: "data_sub_title",
                                                                      cols: "12",
                                                                      align:
                                                                        "left",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.tsc(
                                                                          "all"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-0 pl-2",
                                                                    attrs: {
                                                                      id: "data_count",
                                                                      cols: "12",
                                                                      align:
                                                                        "left",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .totalCountList[
                                                                          index
                                                                        ]
                                                                          .total +
                                                                          _vm.tsc(
                                                                            "peopleCount"
                                                                          )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-1",
                                                                attrs: {
                                                                  cols: "6",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-0 pl-2",
                                                                    attrs: {
                                                                      id: "data_sub_title",
                                                                      cols: "12",
                                                                      align:
                                                                        "left",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.tsc(
                                                                          "faceRecognition"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-0 pl-2",
                                                                    attrs: {
                                                                      id: "data_count",
                                                                      cols: "12",
                                                                      align:
                                                                        "left",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .totalCountList[
                                                                          index
                                                                        ]
                                                                          .known +
                                                                          _vm.tsc(
                                                                            "peopleCount"
                                                                          )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-0 pr-2 pb-3",
                                                    staticStyle: {
                                                      position: "relative",
                                                    },
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c("BarChart", {
                                                      attrs: {
                                                        "chart-data":
                                                          _vm.visitorDataseList[
                                                            index
                                                          ],
                                                        options:
                                                          _vm.chartOptionsList[
                                                            index
                                                          ],
                                                        height: 75,
                                                      },
                                                    }),
                                                    _vm.fetchLoading == false &&
                                                    _vm.visitorDataseList[index]
                                                      .datasets[0].data
                                                      .length == 0
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              id: "no_data",
                                                              cols: "12",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.t(
                                                                    "noData"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                    _vm.authorities.GET_RECORDING_SUB_BRANCH
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "9" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                staticStyle: {
                                                  cursor: "pointer",
                                                },
                                                attrs: {
                                                  id: "data_box",
                                                  cols: "12",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goStoreCCTV(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-3 pl-5 pr-5 pb-4",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0 mb-1",
                                                        staticStyle: {
                                                          "font-weight": "bold",
                                                        },
                                                        attrs: {
                                                          align: "center",
                                                          justify:
                                                            "space-between",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              id: "data_sub_title",
                                                              cols: "auto",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.tsc(
                                                                    "camera"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              cols: "auto",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                staticStyle: {
                                                                  color:
                                                                    "#008DD0",
                                                                  "font-size":
                                                                    "0.8rem",
                                                                },
                                                                attrs: {
                                                                  align:
                                                                    "center",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.tsc(
                                                                        "viewCameras"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                                _c("v-img", {
                                                                  staticClass:
                                                                    "ma-0 pa-0 ml-2",
                                                                  attrs: {
                                                                    "max-height":
                                                                      "0.8rem",
                                                                    "max-width":
                                                                      "0.8rem",
                                                                    src: require("@/assets/images/blue_right_icon.png"),
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    item.storeCameras.length !=
                                                    0
                                                      ? _c(
                                                          "v-row",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  align:
                                                                    "center",
                                                                },
                                                              },
                                                              _vm._l(
                                                                item.storeCameras,
                                                                function (
                                                                  item_nest,
                                                                  index_nest
                                                                ) {
                                                                  return _c(
                                                                    "v-col",
                                                                    {
                                                                      key: index_nest,
                                                                      staticClass:
                                                                        "ma-0 pa-0 pr-1 pb-1",
                                                                      attrs: {
                                                                        cols: "3",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-col",
                                                                        {
                                                                          staticClass:
                                                                            "ma-0 pa-0",
                                                                        },
                                                                        [
                                                                          item_nest.streamAble
                                                                            ? _c(
                                                                                "v-img",
                                                                                {
                                                                                  staticClass:
                                                                                    "ma-0 pa-0",
                                                                                  staticStyle:
                                                                                    {
                                                                                      background:
                                                                                        "grey",
                                                                                    },
                                                                                  attrs:
                                                                                    {
                                                                                      height:
                                                                                        "8rem",
                                                                                      "max-width":
                                                                                        "100%",
                                                                                      src: item_nest.thumbnail,
                                                                                    },
                                                                                  on: {
                                                                                    error:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.thumbnailError(
                                                                                          "no_data_box_" +
                                                                                            item_nest.unisCustomerCd +
                                                                                            "_" +
                                                                                            index_nest
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-col",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ma-0 pa-0 no_data_box_style",
                                                                                      attrs:
                                                                                        {
                                                                                          id:
                                                                                            "no_data_box_" +
                                                                                            item_nest.unisCustomerCd +
                                                                                            "_" +
                                                                                            index_nest,
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm.t(
                                                                                              "thumbnailError"
                                                                                            )
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "v-row",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            staticStyle: {
                                                              height: "8rem",
                                                            },
                                                            attrs: {
                                                              align: "center",
                                                              justify: "center",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.t(
                                                                    "noCamera"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          })
                        : _vm._l(3, function (n) {
                            return _c(
                              "v-col",
                              {
                                key: n,
                                staticClass: "ma-0 pa-0 pl-10 pr-7 mb-5",
                                staticStyle: {
                                  "border-top": "1px solid #4C4C4C",
                                },
                                attrs: { cols: "12" },
                              },
                              [
                                _c("v-col", {
                                  staticClass: "ma-0 pa-3",
                                  staticStyle: { height: "4rem" },
                                  attrs: { cols: "12" },
                                }),
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { align: "center" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "3" },
                                      },
                                      [
                                        _c("v-skeleton-loader", {
                                          attrs: {
                                            boilerplate: false,
                                            elevation: "0",
                                            dark: "",
                                            type: "image",
                                            width: "100%",
                                            height: "11rem",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 pl-4",
                                        attrs: { cols: "9" },
                                      },
                                      [
                                        _c("v-skeleton-loader", {
                                          attrs: {
                                            boilerplate: false,
                                            elevation: "0",
                                            dark: "",
                                            type: "image",
                                            width: "100%",
                                            height: "11rem",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.checkedStoreList.length > 0
            ? _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { id: "bottom_content", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-3",
                      attrs: { align: "center", justify: "end" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 mr-4",
                          attrs: { cols: "auto" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-2",
                              staticStyle: { border: "none" },
                              attrs: {
                                width: "10rem",
                                height: "auto",
                                id: "blue_btn",
                                elevation: "0",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.selectGroupDialogVisible = true
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.tsc("addGroup")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("BrandSearchDialog", {
        attrs: { dialogVisible: _vm.brandSearchDialogVisible },
        on: {
          visible: _vm.brandSearchDialogVisibleFunc,
          editBrands: _vm.editBrandsFunc,
        },
      }),
      _c("StoreSearchDialog", {
        attrs: { dialogVisible: _vm.storeSearchDialogVisible },
        on: {
          visible: _vm.storeSearchDialogVisibleFunc,
          editArea: _vm.editAreaFunc,
        },
      }),
      _c("FilterDialog", {
        attrs: {
          dialogVisible: _vm.filterDialogVisible,
          brandBoxVisible: false,
          filterData: _vm.filteredData,
        },
        on: {
          visible: _vm.filterDialogVisibleFunc,
          filterParams: _vm.filterParamsFunc,
        },
      }),
      _c("TagDialog", {
        attrs: { dialogVisible: _vm.tagDialogVisible },
        on: {
          tagVisible: _vm.tagDialogVisibleFunc,
          tagNames: _vm.tagNamesFunc,
        },
      }),
      _c("SelectGroupDialog", {
        attrs: {
          dialogVisible: _vm.selectGroupDialogVisible,
          checkStore: _vm.checkedStoreList,
        },
        on: { visible: _vm.selectGroupDialogVisibleFunc },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }